/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import type {
  ContentServiceV1,
  LocaleServiceV1,
  AudiFootnoteRefernceServiceScopeManagerInterfaceV3,
  VueFormatterServiceInterfaceV1,
} from '../feature-service-types';

import { ContentContext } from './ContentContext';
import mapContent from '../contentMapping/contentMapping';

export const ContextProvider: React.FC<{
  featureAppId: string;
  children?: React.ReactNode;
  contentService: ContentServiceV1;
  localeService: LocaleServiceV1;
  loggerService: any;
  footnoteReferenceService: AudiFootnoteRefernceServiceScopeManagerInterfaceV3;
  vueFormatterService: VueFormatterServiceInterfaceV1;
}> = ({
  featureAppId,
  vueFormatterService,
  contentService,
  localeService,
  loggerService,
  footnoteReferenceService,
  children,
}) => {
  const [rawContent, setRawContent] = React.useState<any>(contentService?.getContent());

  let content = null;

  React.useEffect(() => {
    const listener = () => {
      setRawContent(contentService?.getContent());
    };
    contentService?.onContentChange(listener);

    return () => {
      contentService?.removeOnContentChange(listener);
    };
  }, [contentService]);

  content = mapContent(rawContent);

  return (
    <ContentContext.Provider
      value={{
        content,
        footnoteReferenceService,
        featureAppId,
        vueFormatterService,
        localeService,
        loggerService,
      }}
    >
      {children}
    </ContentContext.Provider>
  );
};

ContextProvider.displayName = 'ContextProvider';
